/* eslint-disable @typescript-eslint/no-unused-vars */
import React, { useState, useEffect } from 'react'
import {  useDispatch, useSelector } from "react-redux";

import { blue, red, deepOrange, deepPurple, green, pink } from '@mui/material/colors';
import ReactMarkdown from 'react-markdown';
import dayjs from 'dayjs'


// components
import Box from "@mui/material/Box";
import Typography from "@mui/material/Typography";
import Grid from '@mui/material/Grid';
import CircularProgress from '@mui/material/CircularProgress';

// my-components
import Centered from '../../../components/Centered';
import PhysicianListWidget from '../modules/physicians/physician-list.component'
import AppLink from '../../../components/AppLink';


import { ActivityTrail, Physician } from "../../../models";
import { selectDashboardState, selectDashboardLoading, selectUnverified } from '../store/selectors';
import { getDashboardAction } from '../store/actions';

 
const categories = [{
    stateCollected: "totalMeetingsScheduled",
    title: "Scheduled",
    bgColor: 'rgba(148, 115, 243, 0.1)',
    color: '#9473F3'
},
{
    stateCollected: "totalMeetingsPending",
    title: "Pending",
    bgColor: 'rgba(51, 108, 251, 0.1)',
    color: '#336CFB'
},
{
    stateCollected: "totalMeetingsCompleted",
    title: "Completed",
    bgColor: 'rgba(3, 181, 10, 0.1)',
    color: '#03B50A'
},

{
    stateCollected: "totalMeetingsCancelled",
    title: "Cancelled",
    bgColor: 'rgba(255, 144, 67, 0.1)',
    color: '#FF9043'
},
];


const Dashboard = () => {
    const dispatch = useDispatch()
    const Colors = [
        blue, red, deepOrange, deepPurple, green, pink

    ]
    const dashboard = useSelector(selectDashboardState);
    const dashboardUnverifiedPhysicians = useSelector(selectUnverified<number>('unverifiedPhysicians'));
    
    const isLoading =  useSelector(selectDashboardLoading);
    const loadingTrail = false;

    const [unverifiedPhysicians, setUnverifiedPhysicians] = useState<Physician[]>([]);
    const [activityTrail, setActivityTrail] = useState<ActivityTrail[]>([])
    

    const getColor = (index: number) => {
        let avatarBgColor = (Colors[index % unverifiedPhysicians.length]) || blue;
        return avatarBgColor[500];

    }
    const loadingIndicator = isLoading ? (
        <Centered sx={{ height: '100%' }}>
            <CircularProgress />
        </Centered>
    ) : <React.Fragment />;
    useEffect(() => {
        dispatch(getDashboardAction.request({}, {}));
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    return (
        <Box sx={{ flexGrow: 1 }} padding="1em">
            <Grid container spacing={2}>
                <Grid item sm={12} md={6}>

                    <Typography variant="subtitle1" fontSize={'12px'} color="inherit">
                        Recent Activity
                    </Typography>
                    {loadingTrail && loadingIndicator}
                    <div style={{
                        fontFamily: 'Lato, sans-serif',
                        width: '90%',
                        padding: '1em 0 1em 1em',
                        fontSize: '14px',
                        
                        borderLeft: '2px solid ' + blue[500]
                    }}>
                        {activityTrail.map((activity, index) => (
                           <Box key={'dashboard-activity-' + index}  sx={{
                               position: 'relative',
                               '& a': {
                                   textDecoration: 'none'
                               },
                               "&::before": {
                                content: "' '",
                                position: 'absolute',
                                left: '-24px',
                                height: '18px',
                                width: '18px',
                                backgroundColor:  blue[500],
                                borderRadius: '9px',

                               }
                           }}><ReactMarkdown linkTarget={"_blank"} >{(activity.description || "**Error**") }</ReactMarkdown>
                           <small>{dayjs(activity.createdAt).format("MMM D")}</small>
                           </Box> 
                        ) )}
                    </div>
                </Grid>

                <Grid item sm={12} md={6} >
                    <Box>
                        <Typography variant="subtitle1" fontSize={'12px'} color="inherit" style={{marginBottom: '1em'}}>
                            Appointments
                        </Typography>
                    <Grid container spacing={1}>

                        {
                            categories.map((item, index) => (
                                <Grid item xs={6} key={"dashboard-appointment-item-" + index}>
                                    <Box bgcolor={item.bgColor} color={item.color} display={'block'} borderRadius={'20px'} padding="1em 1.4em">
                                        {isLoading && loadingIndicator}
                                        {!isLoading && (<>
                                            <Typography variant='h4' component={'h4'} fontWeight={"bold"} color="inherit" >
                                                {dashboard[item.stateCollected]}
                                            </Typography>
                                            <Typography variant="subtitle1" fontSize={'12px'} color="inherit">
                                                {item.title}
                                            </Typography>
                                        </>)}
                                    </Box>
                                </Grid>
                            ))
                        }
                    </Grid>
                    </Box>
                </Grid>

                <Grid item sm={12} md={6}>
                    <Box>
                        <Box display="flex" sx={{

                            width: '70%',
                            maxWidth: '350px',
                            minWidth: '280px',
                            alignItems: 'center',
                            mb: 2
                        }} >
                            <Typography variant="subtitle1" fontSize={'12px'} color="inherit" flexGrow={1}>
                                Unverified Physicians({dashboardUnverifiedPhysicians})
                            </Typography>
                            {(dashboardUnverifiedPhysicians > unverifiedPhysicians.length) && (<AppLink doNotUseButton style={{
                                color: blue[500]
                            }} to={'physicians/search?crieteria=' + encodeURIComponent(JSON.stringify({ isVerified: false }))}>
                                View All
                            </AppLink>)}
                        </Box>
                        {loadingIndicator}
                        {(!unverifiedPhysicians.length && !isLoading) && (
                            <Box height={'300px'}>
                                <Centered sx={{ height: '100%' }}>
                                    <Typography variant="subtitle1" color="inherit">
                                        No Unverified Physicians found
                                    </Typography>
                                </Centered>
                            </Box>
                        )}
                        {unverifiedPhysicians.map((physician, index) => (
                            <PhysicianListWidget physician={physician} key={'unverified-physician-' + index} avatarBgColor={getColor(index)} />
                        ))}
                    </Box>
                </Grid>

                <Grid item sm={12} md={6}>
                    <Centered>
                        <Typography variant='h4' component={'h4'} fontWeight={"bold"}>
                           {" "}
                        </Typography>
                    </Centered>

                </Grid>

            </Grid>
        </Box>
    )
}

export default Dashboard;
